export default __webpack_public_path__ + "static/P_SearchThumb_IN-9420WQHD_Downloads-afca44b9d72523752a7b2030edb6c889.webp";